import { EResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setSubdomain = actionGenerator<EResultsActionType.SetSubdomain, string>(EResultsActionType.SetSubdomain);
